import { usePageData } from "../../../contexts/PageData";
import styled from "@emotion/styled";

import { Link } from "react-router-dom";

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, Divider, IconButton, Tooltip, lighten } from "@mui/material";

import { CardBlock, CardBlockHeader, CardBlockContainer, CardSpacer } from "../../../utils/utilities/CardComponents";

import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import HideSourceRoundedIcon from '@mui/icons-material/HideSourceRounded';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import AddIcon from '@mui/icons-material/AddRounded';

import useSnackbarStore from "../../../store/snackbar";

import { BasicFlex, LabelUpper } from "../../../utils/Common";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { getAppliedPayments } from "../apiService";

import { removeAppliedPayment } from "../../Vendor_Payments/apiService";

import MultiStatusChip from "../../../utils/utilities/MultiStatusChip";

import { formatCurrency, formatGenericDate } from "../../../utils/util";

import { methods } from "../../Payments/helpers";

import NoItemsFound from "../../../utils/NoItems";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import AppliedPayments from "../../Vendor_Payments/Components/AppliedPayments";

// import AvailablePayments from "../Components/AvailablePayments";

const PaymentTileStyles = styled(BasicFlex)`
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 5px;
  /* margin: 1rem 0; */
  background-color: white;
  align-items: stretch;
  min-height: 10rem;
  margin-bottom: 1.5rem;
`;

const AppliedInfo = styled(BasicFlex)`
 /* min-width: 20rem; */
 background-color: ${props => lighten(props.theme.colors.secondaryFaint, 0.3)};
 padding: 2rem;
 gap: 1rem;
 max-width: 25rem;
`;

/* applied styles */
  const AppliedAmount = styled.div`
    font-weight: 600;
    font-size: 2.6rem;
    color: ${props => props.theme.colors.mildText};
  `;

  const Subheader = styled.div`
    font-weight: 500;
    font-size: 1.4rem;
    color: ${props => props.theme.colors.mildText};
  `;

  const AppliedDate = styled(BasicFlex)`
    font-size: 1.4rem;
    width: fit-content;
  `;
/* end applied styles */

const OriginalInfo = styled(BasicFlex)`
  flex-grow: 1;
  padding: 1rem;
`; 

/* original styles */
const OriginalHeader = styled.div`
  font-weight: 500;
  font-size: 1.2rem;
  color: ${props => props.theme.colors.mildText};
  margin-bottom: 1rem;
  text-transform: uppercase;
`;

const OriginalDetails = styled(BasicFlex)`
  flex-grow: 1;
`;

const OriginalDetailsContainer = styled(BasicFlex)`
  height: 100%;
`;

const OriginalAmount = styled(BasicFlex)`
  font-size: 1.2rem;
  color: ${props => props.theme.colors.mildText};
  width: auto;
  min-width: fit-content;
  padding: 0 2rem;
  height: 100%;
  gap: .2rem;

  div {
    width: fit-content;
  }

  .amount {
    font-size: 1.8rem;
    font-weight: 600;
  }
`;

const OriginalPaymentDetails = styled(BasicFlex)`
  flex-direction: column;
  gap: 1rem;
  flex-wrap: wrap;
  max-height: 10rem;
  margin-left: 2rem;
`;

const SmallTileStyles = styled(BasicFlex)`
  border: 1px solid ${props => props.theme.colors.border};
  background-color: ${props => props.theme.colors.lightBg};
  padding: .2rem .6rem;
  border-radius: 5px;
  width: fit-content;
  font-size: 1.2rem;
  gap: .6rem;
`;

const SmallTileHeader = styled.div`
  color: ${props => props.theme.colors.mildText};
  text-transform: uppercase;
`;

const SmallTileInfo = styled.div`
  font-weight: 500;
`;
/* end original styles */

const Actions = styled(BasicFlex)`
  gap: 1rem;
  width: 10rem;
`;


const PaymentsTab = () => {

 const { data = {} } = usePageData();

 const { data: payments } = useQuery({
  queryKey: ['bills', data.bill_id],
  queryFn: () => getAppliedPayments(data.bill_id),
  enabled: !!data.bill_id
 });

 console.log(payments, "payments");

  const billBlock = [
    {header: "Bill Total",  info: data.total, dataType: "currency"},
    {header: "Paid Status", info: <MultiStatusChip value={data.paid_status} values={[{value: "unpaid", label: "Unpaid", status: "error"}, {value: "partially_paid", label: "Partially Paid", status: "warning"}, {value: "paid", label: "Paid", status: "success"}]} />},
    {header: "Paid Amount", info: data.total_paid, dataType: "currency"},
    {header: "Balance", info: data.balance, dataType: "currency"},
  ]

 return (
  <Grid container spacing={3}>
    <Grid size={{xs: 12, md: 8}}>
      <Card elevation={0} sx={{backgroundColor: "transparent"}}>
      <CardHeader title="List of Applied Payments" sx={{p: 1}} />
        <AppliedPayments payments={payments} />
      </Card>
    </Grid>

    <Grid size={{xs: 12, md: 4}}>
      <Card variant='outlined'>
        <CardHeader title="Balance and Payments" />
        <CardContent>
          <CardBlockContainer>
            {billBlock.map((block) => (
              <CardBlock key={block.header} header={block.header} info={block.info} dataType={block.dataType} />
            ))}
          </CardBlockContainer>
        </CardContent>

        <CardActions sx={{display: "flex", flexDirection: "column"}}>
          <Link to={`/vendor_payments/edit`} state={{vendor_id: data.vendor_id?.toString(), vendor_name: data.vendor?.full_name, mobile_phone: data.vendor?.mobile_phone, email: data.vendor?.email}} style={{width: "100%"}} >
            <Button fullWidth variant="outlined" startIcon={<AddIcon />}>Add New Payments</Button>
          </Link>
        </CardActions>
      </Card>
    </Grid>

    {/* <Grid size={{xs: 12, md: 8}}>
      {data.balance > 0 ? <AvailablePayments /> : null}
    </Grid> */}

  </Grid>
 )
};

export default PaymentsTab;